import {ContainerBinder} from '../../../IoC/ContainerBinder';
import {TableStorage, TableUrlStorage} from '../stores/TableStorage';

export const bindTableModule = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bind(TableStorage, TableUrlStorage)
    .done();
};
